import React from 'react';

export const ForgeAdamVitareqSearchResultIcon = () => {
	return (
		<svg
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			x="0px"
			y="0px"
			width="32"
			height="32"
			viewBox="0 0 120 120"
			enableBackground="new 0 0 120 120"
			xmlSpace="preserve"
		>
			<path
				fill="#F4EAE8"
				opacity="1.000000"
				stroke="none"
				d="
M76.000000,121.000000
C50.666668,121.000000 25.833334,121.000000 1.000000,121.000000
C1.000000,81.000000 1.000000,41.000000 1.000000,1.000000
C41.000000,1.000000 81.000000,1.000000 121.000000,1.000000
C121.000000,41.000000 121.000000,81.000000 121.000000,121.000000
C106.166664,121.000000 91.333336,121.000000 76.000000,121.000000
M62.263176,19.060066
C50.996426,19.075516 42.247055,24.466097 38.773026,34.221611
C37.638844,37.406521 35.857670,38.863720 32.982101,40.200188
C23.188688,44.751854 17.890841,55.936722 20.272135,66.484962
C22.861870,77.956520 33.360901,84.342522 43.491947,86.014969
C50.326443,87.143219 55.707760,84.249313 60.596325,79.992630
C65.522552,75.703156 70.984940,72.981033 77.720123,72.948860
C85.075142,72.913742 89.779495,68.094574 89.990685,60.712646
C90.087982,57.311523 90.007256,53.905312 90.007256,49.725838
C96.250122,54.823402 95.770119,61.053692 94.653046,66.727623
C93.452408,72.825928 88.920235,76.874992 82.747787,78.246613
C79.439178,78.981842 77.959923,80.470528 77.013176,83.756348
C73.641945,95.456734 60.734417,99.714951 50.472446,93.147980
C47.960659,91.540611 44.484413,91.440361 41.451588,90.647202
C41.322243,91.170441 41.192898,91.693680 41.063553,92.216919
C46.222862,99.533493 53.364048,103.372185 62.318932,102.654411
C71.656143,101.905991 78.349434,96.896553 82.437683,88.297714
C83.302124,86.479515 85.176079,84.676788 87.023216,83.868111
C96.678192,79.641167 102.544991,70.587334 102.005142,60.097221
C101.507645,50.430080 94.254456,41.358860 84.230858,39.029640
C74.934387,36.869381 65.991173,36.725124 58.192295,44.358093
C55.084240,47.400028 49.996651,49.980045 45.790779,50.009647
C37.440773,50.068432 32.053486,53.933083 31.886557,62.435261
C31.819893,65.830574 31.875595,69.228287 31.875595,73.554253
C30.563459,72.398857 30.028196,72.063705 29.671417,71.593216
C22.798084,62.529270 26.230907,50.123062 36.850655,45.365486
C39.658077,44.107780 43.220943,43.915871 43.857868,39.645134
C44.827877,33.141006 48.736507,28.318781 54.905392,26.711372
C61.303562,25.044220 68.092499,25.058596 73.042778,30.892323
C75.655090,33.970844 78.177010,33.326168 81.226646,31.431835
C77.141373,24.014318 70.877846,20.473303 62.263176,19.060066
z"
			/>
			<path
				fill="#E56060"
				opacity="1.000000"
				stroke="none"
				d="
M62.693012,19.088871
C70.877846,20.473303 77.141373,24.014318 81.226646,31.431835
C78.177010,33.326168 75.655090,33.970844 73.042778,30.892323
C68.092499,25.058596 61.303562,25.044220 54.905392,26.711372
C48.736507,28.318781 44.827877,33.141006 43.857868,39.645134
C43.220943,43.915871 39.658077,44.107780 36.850655,45.365486
C26.230907,50.123062 22.798084,62.529270 29.671417,71.593216
C30.028196,72.063705 30.563459,72.398857 31.875595,73.554253
C31.875595,69.228287 31.819893,65.830574 31.886557,62.435261
C32.053486,53.933083 37.440773,50.068432 45.790779,50.009647
C49.996651,49.980045 55.084240,47.400028 58.192295,44.358093
C65.991173,36.725124 74.934387,36.869381 84.230858,39.029640
C94.254456,41.358860 101.507645,50.430080 102.005142,60.097221
C102.544991,70.587334 96.678192,79.641167 87.023216,83.868111
C85.176079,84.676788 83.302124,86.479515 82.437683,88.297714
C78.349434,96.896553 71.656143,101.905991 62.318932,102.654411
C53.364048,103.372185 46.222862,99.533493 41.063553,92.216919
C41.192898,91.693680 41.322243,91.170441 41.451588,90.647202
C44.484413,91.440361 47.960659,91.540611 50.472446,93.147980
C60.734417,99.714951 73.641945,95.456734 77.013176,83.756348
C77.959923,80.470528 79.439178,78.981842 82.747787,78.246613
C88.920235,76.874992 93.452408,72.825928 94.653046,66.727623
C95.770119,61.053692 96.250122,54.823402 90.007256,49.725838
C90.007256,53.905312 90.087982,57.311523 89.990685,60.712646
C89.779495,68.094574 85.075142,72.913742 77.720123,72.948860
C70.984940,72.981033 65.522552,75.703156 60.596325,79.992630
C55.707760,84.249313 50.326443,87.143219 43.491947,86.014969
C33.360901,84.342522 22.861870,77.956520 20.272135,66.484962
C17.890841,55.936722 23.188688,44.751854 32.982101,40.200188
C35.857670,38.863720 37.638844,37.406521 38.773026,34.221611
C42.247055,24.466097 50.996426,19.075516 62.693012,19.088871
M83.824944,56.293854
C83.821907,53.635612 83.976067,50.963406 83.741730,48.325714
C83.642090,47.204105 82.797951,45.259941 82.174835,45.211914
C76.359108,44.763695 70.118729,42.530880 65.076790,47.276245
C59.155472,52.849270 52.615253,56.469597 44.212204,56.320381
C40.653618,56.257191 38.137321,58.196499 38.040661,62.073360
C37.913185,67.186157 38.009319,72.304527 38.009319,77.448776
C45.517998,80.035103 51.614822,79.032494 57.772171,74.282555
C61.946938,71.062035 67.295502,67.884392 72.307640,67.554817
C81.082947,66.977783 83.710907,65.678894 83.824944,56.293854
z"
			/>
			<path
				fill="#F4E9E7"
				opacity="1.000000"
				stroke="none"
				d="
M83.824799,56.751064
C83.710907,65.678894 81.082947,66.977783 72.307640,67.554817
C67.295502,67.884392 61.946938,71.062035 57.772171,74.282555
C51.614822,79.032494 45.517998,80.035103 38.009319,77.448776
C38.009319,72.304527 37.913185,67.186157 38.040661,62.073360
C38.137321,58.196499 40.653618,56.257191 44.212204,56.320381
C52.615253,56.469597 59.155472,52.849270 65.076790,47.276245
C70.118729,42.530880 76.359108,44.763695 82.174835,45.211914
C82.797951,45.259941 83.642090,47.204105 83.741730,48.325714
C83.976067,50.963406 83.821907,53.635612 83.824799,56.751064
z"
			/>
		</svg>
	);
};
